"use client";

import { VimeoPhoneVideo } from "@/components/educators/components/VimeoPhoneVideo";
import { RYAN_VIDEO_TRANSCRIPT } from "@/components/educators/data/video-transcripts";
import { SectionFrame } from "@/components/ui/section-frame";
import Link from "next/link";

export function RyanSpotlightSection() {
  return (
    <SectionFrame
      startColor="rgb(var(--accent-lime))"
      endColor="rgb(var(--accent-teal))"
      flipped={true}
      clipOverflowX={false}
      contentClassName="pt-0 pb-16"
    >
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-start">
          <div className="flex flex-col gap-6 order-2 lg:order-1">
            <div>
              <p className="text-ink-slate font-extrabold text-lg md:text-xl">Ryan, Math Teacher</p>
              <p className="mt-2 charlie-kingdom-font text-brand-purple-deep text-3xl md:text-4xl leading-tight">
                Try something new
              </p>
            </div>

            <p className="text-ink-slate font-semibold text-base md:text-lg leading-relaxed">
              Ryan says taking chances with new resources is how educators grow. PlayMath.org kept
              his students focused on real math skills through fun activities: quick to start, no
              ads or sign-ups, and free. He uses it for stations, early finishers, brain breaks, and
              those moments when a lesson needs a reset.
            </p>

            <div className="pt-2">
              <Link
                href="/games"
                className="w-full max-w-[520px] inline-flex items-center justify-center bg-cta-yellow text-black rounded-full border-4 border-black shadow-cta-yellow px-8 py-5 charlie-kingdom-font text-xl md:text-2xl hover:bg-cta-yellow-hover transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-black/20"
              >
                <span className="relative -top-1">Explore free math games</span>
              </Link>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <VimeoPhoneVideo
              outerClassName="flex justify-center lg:-mt-24 bg-[url('/images/marketing/educators/featured/kristen/blob.svg')] bg-center bg-contain bg-no-repeat"
              phoneContainerClassName="rotate-[2.5deg]"
              src="https://player.vimeo.com/video/1210458418?title=0&byline=0&portrait=0&controls=0&playsinline=1&api=1&player_id=ryan-vimeo"
              title="Ryan educator spotlight video"
              transcript={RYAN_VIDEO_TRANSCRIPT}
              transcriptTestId="ryan-transcript"
            />
          </div>
        </div>
      </div>
    </SectionFrame>
  );
}
